import React, { useEffect, useState } from "react";
import { ProjectBrouchureProps } from "../../../interfaces/projects";
import { transformCloudinaryImg } from "../../../services/utils";
import SlideInDown from "../../Animations/slideInDown";
import SlideInLeft from "../../Animations/slideInLeft";
import Width from "../../Animations/width";
import "./brouchure.scss";

interface BrouchureImages {
  primary: string;
  main: string;
  last: string;
}

const ProjectBrouchure: React.FC<ProjectBrouchureProps> = ({
  title,
  subtitle,
  brouchureSrc,
  brouchureSrcMobile,
  colors,
  images,
  templateImgs = "default",
}) => {
  const [brouchureSource, setBrouchureSource] = useState<string>(brouchureSrc);
  const [imagesSrc, setImagesSrc] = useState<BrouchureImages>({
    primary: "",
    main: "",
    last: "",
  });

  useEffect(() => {
    if (typeof window !== `undefined`) {
      const { clientWidth } = document.documentElement;
      const isMobile = clientWidth <= 768;
      const imgs: BrouchureImages = { primary: "", main: "", last: "" };

      brouchureSrcMobile && isMobile && setBrouchureSource(brouchureSrcMobile);

      if (templateImgs === "default") {
        imgs.main = transformCloudinaryImg(
          images.main,
          isMobile
            ? "c_fill,f_auto,q_80,h_450,w_580"
            : "c_fill,f_auto,q_80,h_350,w_800"
        );

        imgs.primary = transformCloudinaryImg(
          images.primary,
          isMobile
            ? "c_fill,f_auto,q_80,h_480,w_430"
            : "c_fill,f_auto,q_80,h_460,w_440"
        );

        imgs.last = transformCloudinaryImg(
          images.last,
          isMobile
            ? "c_fill,f_auto,q_80,h_320,w_380"
            : "c_fill,f_auto,q_80,h_220,w_325"
        );
      }

      if (templateImgs === "two-horizontal") {
        imgs.main = transformCloudinaryImg(
          images.main,
          isMobile ? "c_fill,f_auto,q_80,w_600" : "c_fill,f_auto,q_80,w_900"
        );

        imgs.primary = transformCloudinaryImg(
          images.primary,
          isMobile ? "c_fill,f_auto,q_80,w_600" : "c_fill,f_auto,q_80,w_900"
        );
      }

      setImagesSrc({
        primary: imgs.primary,
        main: imgs.main,
        last: imgs.last,
      });
    }
  }, []);

  return (
    <section
      className="brouchure"
      id="brouchure"
      style={{ backgroundImage: `url(${images.background})` }}
    >
      <div className="container">
        <div className="flex brouchure-content">
          <div className="left-content flex-1">
            <SlideInLeft distance={50} duration={0.6}>
              <h2
                dangerouslySetInnerHTML={{ __html: title }}
                style={{ color: colors.primary }}
                className="montserrat-light"
              />
            </SlideInLeft>
            {/* <Width width="200px" widthMobile="80%">
              <hr
                style={{
                  borderColor: colors.secondary,
                  backgroundColor: colors.secondary,
                }}
              />
            </Width> */}
            <SlideInLeft distance={50} duration={0.6}>
              <h4
                dangerouslySetInnerHTML={{ __html: subtitle }}
                style={{ color: colors.primary }}
                className="montserrat-light"
              />
            </SlideInLeft>

            {brouchureSource && (
              <SlideInDown distance={100} duration={0.8}>
                <a
                  className="button-brouchure font-bold"
                  href={brouchureSource}
                  target="_blank"
                  // style={{
                  //   color: colors.primary,
                  //   backgroundColor: colors.secondary,
                  // }}
                >
                  Descargar brouchure{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 17 14"
                  >
                    <path
                      fill="#E94F1B"
                      d="m9.92 14-1.02-.98 5.37-5.32H0V6.3h14.27L8.9 1l1.02-1L17 7l-7.08 7Z"
                    />
                  </svg>
                </a>
              </SlideInDown>
            )}
          </div>
          <div
            className={`right-content flex-1 ${
              templateImgs === "two-horizontal"
                ? "two-horizontal-content"
                : null
            }`}
          >
            {templateImgs === "default" && (
              <div className="flex-column h-100">
                <div className="circles-wrap">
                  <div className="circles">
                    <div className="circle">
                      <img
                        src={imagesSrc?.primary}
                        alt=""
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <div className="circle">
                      <img
                        src={imagesSrc?.last}
                        alt=""
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <div className="circle">
                      <img
                        src={imagesSrc?.main}
                        alt=""
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {templateImgs === "two-vertical" && <div className=""></div>}
            {templateImgs === "two-horizontal" && (
              <div className="circles-wrap">
                <div className="circles">
                  <div className="circle">
                    <img
                      src={imagesSrc?.primary}
                      alt=""
                      loading="lazy"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div className="circle">
                    <img
                      src={imagesSrc?.main}
                      alt=""
                      loading="lazy"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectBrouchure;
